import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Block, Category, Page } from 'src/app/apps/website/interfaces/PagesCategories';
import * as g from '../../globals';
@Injectable({
  providedIn: 'root'
})
export class WebsiteService {
  clearPanelEmitter = new EventEmitter();
  initContentEmitter = new EventEmitter();
  refreshEmitter = new EventEmitter();
  constructor(
    private http: HttpClient
  ) { }

  //#region websites
  getWebsites() {
    return this.http.get(`${g.apiBaseUrl}Websites/GetWebsites`);
  }
  getWebsiteById(id) {
    return this.http.get(`${g.apiBaseUrl}Websites/GetWebsiteById?&id=${id}`);
  }
  saveWebsite(website) {
    return this.http.post(`${g.apiBaseUrl}Websites/SaveWebsite`, website);
  }
  //#endregion
  //#region Pages
  getPages(): Observable<Page[]> {
    return this.http.get<Page[]>(`${g.apiBaseUrl}Websites/GetPages`);
  }
  getPageById(id: number): Observable<Page> {
    return this.http.get<Page>(`${g.apiBaseUrl}Websites/GetPageById?id=${id}`);
  }
  getPageByCode(code: string) {
    return this.http.get<Page>(`${g.apiBaseUrl}Websites/GetPageByCode?code=${code}`);
  }
  getPagesOfCategoryCode(code: string) {
    return this.http.get(`${g.apiBaseUrl}Websites/GetPagesOfCategoryCode?code=${code}`);
  }
  savePage(page: Page) {
    return this.http.post(`${g.apiBaseUrl}Websites/SavePage`, page);
  }
  //#endregion

  //#region Categories
  getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${g.apiBaseUrl}Websites/GetCategories`);
  }
  getCategoryById(id: number) {
    return this.http.get<Category>(`${g.apiBaseUrl}Websites/GetCategoryById?id=${id}`);
  }
  getCategoryByCode(code: string) {
    return this.http.get<Page>(`${g.apiBaseUrl}Websites/GetCategoryByCode?code=${code}`);
  }
  //#endregion

  //#region blocks
  getBlocks(): Observable<Block[]> {
    return this.http.get<Block[]>(`${g.apiBaseUrl}Websites/GetBlocks`);
  }
  getBlockById(id: number): Observable<Block> {
    return this.http.get<Block>(`${g.apiBaseUrl}Websites/GetBlockById?id=${id}`);
  }
  getBlockByCode(code: string): Observable<Block> {
    return this.http.get<Block>(`${g.apiBaseUrl}Websites/GetBlockByCode?code=${code}`);
  }
  saveBlock(block: Block) {
    return this.http.post(`${g.apiBaseUrl}Websites/SaveBlock`, block);
  }
  //#endregion
}
